import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestRwdacct } from "../../entity/EntityRequestRwdacct";

export class DtoRequestRwdacctsPostReq extends EntityRequestRwdacct {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
